import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseService } from 'tms-web-shared';
import { ProductionProgressBoard } from '../../../models';

@Injectable({
  providedIn: 'root',
})
// The production progress board (PRD weaving-production-progress-board): read-only.
export class ProductionProgressService extends TmsWebBaseService {
  constructor() {
    super('ProductionProgressBoard');
  }

  getBoard(): Observable<ProductionProgressBoard> {
    return this.httpService.get<ProductionProgressBoard>(`${this.apiUrl}/Board`);
  }
}
